import React from "react";
import ApplicationImg from "../assets/img/applicationImg.png";
import Mail from "../assets/img/email.svg";
import Phone from "../assets/img/Phone.svg";
import Location from "../assets/img/Location.svg";
import ContactBg from "../assets/img/contactBg.png"

const ContactUs = () => {
  return (
    <div className="container mx-auto px-4">
       <div className="block bg-white h-[130px]"></div>
      <div className="relative w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
        <img
          src={ContactBg}
          alt="Background"
          className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
            Contact Us
          </h1>
        </div>
      </div>


      <div className="my-16">
        <h3 className="capitalize text-primary text-4xl text-center">
          Need to reach us?
        </h3>
        <div className="my-16 flex flex-wrap gap-6 justify-around">
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Lagos
            </h4>
            <span className="flex gap-2 items-start mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            1st Floor, West End Plaza 25, Montgomery Road, Yaba, Lagos
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 8160300467" className="hover:text-secondary">+234 8160300467</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:lagos@365globalconsulting.com" className="hover:text-secondary">lagos@365globalconsulting.com</a>
            </span> */}
          </div>
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Abuja
            </h4>
            <span className="flex gap-2 items-start mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            Suite 108, De Avalon Plaza, No, 483 Ajose Adeogun Crescent, Utako District, Abuja
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 7012647743" className="hover:text-secondary">+234 7012647743</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:abuja@365globalconsulting.com" className="hover:text-secondary">abuja@365globalconsulting.com</a>
            </span> */}
          </div>
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Kano
            </h4>
            <span className="flex gap-2 items-start mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            35, Lamido Crescent Nassarawa GRA, Kano State
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 7011489807" className="hover:text-secondary">+234 7011489807</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:kano@365globalconsulting.com" className="hover:text-secondary">kano@365globalconsulting.com</a>
            </span> */}
          </div>
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Port Harcourt
            </h4>
            <span className="flex gap-2 items-center mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            The Autograph, 30 Sani Abacha Road GRA phase 3, Port Harcourt
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 7013250504" className="hover:text-secondary">+234 7013250504</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:portharcourt@365globalconsulting.com"className="hover:text-secondary">portharcourt@365globalconsulting.com</a>
            </span> */}
          </div>
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Enugu
            </h4>
            <span className="flex gap-2 items-center mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            Remote
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 9043251001" className="hover:text-secondary">+234 9043251001</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:owerri@365globalconsulting.com" className="hover:text-secondary">owerri@365globalconsulting.com</a>
            </span> */}
          </div>
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Uyo
            </h4>
            <span className="flex gap-2 items-center mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            Remote
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 8167486759" className="hover:text-secondary">+234 8167486759</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:uyo@365globalconsulting.com" className="hover:text-secondary">uyo@365globalconsulting.com</a>
            </span> */}
          </div>
        <div className="border border-gray-neutral w-full max-w-[380px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg mb-6">
              Anambra
            </h4>
            <span className="flex gap-2 items-center mb-2">
            <img src={Location} alt="university" className="py-2" width={26}/>
            <p className="opacity-80">
            Remote
            </p>
            </span>
            <span className="flex gap-2 items-center mb-2">
            <img src={Phone} alt="university" className="py-2" width={26}/>
            <a href="tel:+234 7012526738" className="hover:text-secondary">+234 7012526738</a>
            </span>
            {/* <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:uyo@365globalconsulting.com" className="hover:text-secondary">uyo@365globalconsulting.com</a>
            </span> */}
          </div>
          
          {/* <div className="border border-gray-neutral w-full max-w-[320px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg">
              Just a call away
            </h4>
            <img src={Phone} alt="university" className="py-5"/>
            <a href="tel:+234 81 25853028">+234 81 25853028</a>
            <br />
            <a href="tel:+234 81 25853028">+234 81 25853028</a>
           
          </div>
          <div className="border border-gray-neutral w-full max-w-[320px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg">
            visit us
            </h4>
            <img src={Location} alt="university" className="py-5"/>
            <p className="text-sm opacity-80">
            1st Floor, Hanola Place,25 Montgomery Road, Yaba,Lagos, Nigeria
            </p>
          </div>
          <div className="border border-gray-neutral w-full max-w-[320px] p-6 rounded-2xl">
            <h4 className="capitalize font-bold text-primary text-lg">
            send an email
            </h4>
            <img src={Mail} alt="university" className="py-5"/>
            <a href="mailto:admissions@365globalconsulting.com" >admissions@365globalconsulting.com</a>
            <br/>
            <a href="mailto:info@365globalconsulting.com" >info@365globalconsulting.com</a>
            
          </div> */}
          
        </div>
        {/* <div className="border border-gray-neutral w-full max-w-[520px] p-6 rounded-2xl">
            <img src={Location} alt="university" className="py-2"/>
            <h4 className="capitalize font-bold text-primary text-lg">
              Lagos
            </h4>
            <p className="opacity-80">
            1st Floor, Hanola Place,25 Montgomery Road, Yaba,Lagos, Nigeria
            </p>
            <a href="tel:+234 9066025582">+234 9066025582</a>
            <br />
            <a href="mailto:lagos@365globalconsulting.com" >lagos@365globalconsulting.com</a>
           
          </div> */}
     
       
      </div>
      <div className="flex flex-wrap justify-between items-center mt-24 p-4 md:p-0">
        <div>
          <img src={ApplicationImg} alt="application" />
        </div>
        <div className="w-full md:w-1/2 mt-6">
          <h3 className="text-4xl text-primary">Start a conversation</h3>
          <p className="opacity-60 mt-2 md:w-3/4">
            Contact us today! Our team responds to emails within 1 hour,
            ensuring you get the information you need, fast.
          </p>
          <span className="flex gap-2 items-center mb-2">
            <img src={Mail} alt="university" className="py-2" width={26}/>
            <a href="mailto:info@365globalconsulting.com" className="hover:text-secondary">info@365globalconsulting.com</a>
            </span> 
          <div className="py-10">
        <iframe
        src="https://forms.zohopublic.com/humanresources365global1/form/ContactUs/formperma/N-UVhizreZFDk9X9kFAmfBb7UOCEKNycWVXiPNoENwc"
        width="100%"
        height="600"
        frameBorder="0"
        style={{ border: "none" }}
        allowFullScreen
        title="Zoho Form"
        className="rounded-3xl"
      ></iframe>
        </div>

          {/* <form className="my-16">
            <div className="flex justify-between gap-2">
              <div className="w-full">
                <label className="text-sm">First Name*</label>
                <input
                  type="text"
                  placeholder="First Name"
                  id="firstname"
                  className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
                />
              </div>
              <div>
                <label className="text-sm">Last Name*</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  id="lastname"
                  className="border w-full md:w-[310px] py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
                />
              </div>
            </div>
            <div className="mt-4">
              <label className="text-sm">Phone Number*</label>
              <input
                type="number"
                placeholder="Phone number"
                id="phoneNumber"
                className="border w-full py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
              />
            </div>
            <div className="mt-4">
              <label className="text-sm">Email*</label>
              <input
                type="email"
                placeholder="Email"
                id="phoneNumber"
                className="border w-full py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
              />
            </div>
            <div className="mt-4">
              <label className="text-sm">Message*</label>
              <textarea
                rows={6}
                id="message"
                placeholder="Write message"
                className="border w-full py-3 ps-3 mt-2 border-gray-neutral rounded-lg"
              ></textarea>
            </div>

            <button className="uppercase text-white bg-primary mt-8 py-3 px-8 rounded-full hover:bg-gray-cool duration-300">
              Send message
            </button>
          </form> */}
        </div>

       
      </div>

    </div>
  );
};

export default ContactUs;
